import React from 'react';
import {
  Grid,
  Box,
  Card,
  CardContent,
  Skeleton,
  Divider,
  Container
} from '@mui/material';

const AdminDashboardSkeleton = () => {
  // Helper to create a fake table row look
  const TableRowSkeleton = () => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
      <Skeleton variant="text" width="30%" />
      <Skeleton variant="text" width="30%" />
      <Skeleton variant="text" width="20%" />
    </Box>
  );

  return (
    <div className="main-content" style={{ backgroundColor: '#f0f0f0', minHeight: '100vh', paddingBottom: '20px' }}>
      
      {/* --- Page Title & Date --- */}
      <div className="pagetitle row" style={{ paddingTop: 15, paddingLeft: 15, paddingRight: 15 }}>
        <div className="col-md-10 col-6">
          <Skeleton variant="text" width={200} height={40} />
        </div>
        <div className="col-md-2 col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
           <Skeleton variant="text" width={120} height={30} />
        </div>
      </div>

      <Divider sx={{ mb: 2 }} />

      {/* --- Global Filters Row --- */}
      {/* <Box sx={{ px: { xs: 2, md: 3 }, pb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
          </Grid>
        </Grid>
      </Box> */}


      {/* --- SECTION 2: 3-Column Info (Lists & Small Table) --- */}
      <Box sx={{ px: { xs: 2, md: 3 }, pb: 3 }}>
        <Grid container spacing={2} alignItems="stretch">
          {/* Col 1: Vertical List */}
          <Grid item xs={12} md={3}>
            <Card elevation={2} sx={{ height: '100%' }}>
              <CardContent>
                <Skeleton variant="text" width="80%" height={30} sx={{ mb: 2 }} />
                {[1, 2, 3, 4, 5].map((i) => (
                  <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                    <Skeleton variant="text" width="70%" />
                    <Skeleton variant="text" width="15%" />
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Col 2: Region List */}
          <Grid item xs={12} md={3}>
            <Card elevation={2} sx={{ height: '100%' }}>
              <CardContent>
                <Skeleton variant="text" width="80%" height={30} sx={{ mb: 2 }} />
                {[1, 2, 3, 4, 5].map((i) => (
                  <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                    <Skeleton variant="text" width="70%" />
                    <Skeleton variant="text" width="15%" />
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Col 3: Next 2 Weeks Table */}
          <Grid item xs={12} md={6}>
            <Card elevation={2} sx={{ height: '100%' }}>
              <CardContent>
                <Skeleton variant="text" width="60%" height={30} sx={{ mb: 2 }} />
                {/* Table Header Simulation */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, borderBottom: '1px solid #eee', pb:1 }}>
                   <Skeleton variant="text" width="30%" height={20} />
                   <Skeleton variant="text" width="30%" height={20} />
                   <Skeleton variant="text" width="20%" height={20} />
                </Box>
                {[1, 2, 3].map((i) => <TableRowSkeleton key={i} />)}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>


      {/* --- SECTION 1: Fixtures Dispatched (Large Card) --- */}
      {/* <Box sx={{ px: { xs: 2, md: 3 }, pb: 2 }}>
        <Card elevation={2} sx={{ borderLeft: '4px solid #e0e0e0' }}>
          <CardContent sx={{ py: 2 }}>
            <Skeleton variant="text" width="30%" height={30} sx={{ mb: 2 }} />
            <Grid container spacing={4} justifyContent="space-around">
              {[1, 2, 3, 4].map((item) => (
                <Grid item key={item} sx={{ textAlign: 'center' }}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="text" width={40} height={40} sx={{ mx: 'auto' }} />
                </Grid> 
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Box> */}


      {/* --- KPI Cards --- */}
      {/* <Box sx={{ px: { xs: 2, md: 3 }, pb: 2 }}>
        <Grid container spacing={2}>
          {[1, 2, 3, 4, 5, 6].map((kpi) => (
            <Grid item xs={6} sm={4} md={2} key={kpi}>
              <Card elevation={2} sx={{ height: '100%' }}>
                <CardContent>
                  <Skeleton variant="text" width="60%" sx={{ mx: 'auto', mb: 1 }} />
                  <Skeleton variant="rectangular" width="40%" height={30} sx={{ mx: 'auto', borderRadius: 1 }} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box> */}

      {/* --- Alert Table (Delayed BOMs) --- */}
      <Box sx={{ px: { xs: 2, md: 3 }, pb: 3 }}>
        <Grid item xs={12}>
           {/* Simulate MaterialTable Toolbar + Header */}
           <Skeleton variant="rectangular" height={50} sx={{ mb: 0.5, borderTopLeftRadius: 4, borderTopRightRadius: 4 }} /> 
           {/* Simulate Table Body */}
           <Skeleton variant="rectangular" height={150} sx={{ borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }} />
        </Grid>
      </Box>

      {/* --- Main Table (Project Monitoring) --- */}
      <Box sx={{ px: { xs: 2, md: 3 }, pb: 3 }}>
        <Grid item xs={12}>
           {/* Toolbar */}
           <Skeleton variant="rectangular" height={60} sx={{ mb: 0.5, borderTopLeftRadius: 4, borderTopRightRadius: 4 }} />
           {/* Table Header & Rows */}
           <Skeleton variant="rectangular" height={400} sx={{ borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }} />
        </Grid>
      </Box>

      {/* --- Charts Section --- */}
      <Box sx={{ px: { xs: 2, md: 3 }, pb: 4 }}>
        <Grid container spacing={2}>
          {/* Chart 1 */}
          <Grid item xs={12} md={6}>
            <Card elevation={2}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                    <Skeleton variant="text" width={200} />
                </Box>
                <Skeleton variant="rectangular" height={320} width="100%" />
              </CardContent>
            </Card>
          </Grid>

          {/* Chart 2 */}
          <Grid item xs={12} md={6}>
            <Card elevation={2}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                    <Skeleton variant="text" width={200} />
                </Box>
                <Skeleton variant="rectangular" height={320} width="100%" />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

    </div>
  );
};

export default AdminDashboardSkeleton;